app.controller("ExamsManagerAddSessionController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "StaticData", "$uibModal", "toastr", "params",
    function ($scope, ExamsManagerService, $uibModalInstance, StaticData, $uibModal, toastr, params) {
        console.log(params);

        $scope.examDayId = params.examDay._id;
        $scope.time = new Date(2017, 1, 1, 12, 0);
        $scope.level = null;
        $scope.hallId = null;

        $scope.examHalls = [];
        $scope.levels = [];

        $scope.fetchHalls = function () {
            console.log("aqa");
            ExamsManagerService.fetchExamHalls()
                .then(function (data) {
                    $scope.examHalls = data;
                    console.log(data);
                });
        };

        $scope.fetchLevels = function () {
            StaticData.getItemsByKey("levels").then(function (levels) {
                $scope.levels = levels;
                console.log(levels);
            });
        };

        $scope.fetchHalls();
        $scope.fetchLevels();

        $scope.add = function () {

            if ($scope.level === null || $scope.hallId === null || $scope.level === "" || $scope.hallId === "") {
                toastr.warning('', 'შეავსეთ ყველა ველი');
                return;
            }

            ExamsManagerService.addSession({
                examHallId: $scope.hallId,
                examDayId: $scope.examDayId,
                time: $scope.time,
                level: $scope.level,
            }).then(function (resp) {
                if (resp.status === "ok") {
                    toastr.success('', 'სესია დამატებულია');
                    $uibModalInstance.close();
                } else {
                    toastr.warning('მოცემული დარბაზისთვის და დროისთვის ამ დღეზე სესია უკვე არსებობს.', 'დაფიქსირდა შეცდომა')
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
